<!doctype html>
<html lang="en" xmlns="http://www.w3.org/1999/html">
<head>

  <!-- Basic Page Needs
  ================================================== -->
  <title>ระบบค้นหาและแนะนำรหัสประเภทธุรกิจ - กรมพัฒนาธุรกิจการค้า</title>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
  <base href="/searchResult">

</head>
<body>
<!-- Wrapper -->
<div id="overlay">
	<div class="cv-spinner">
		<span class="spinner"></span>
	</div>
</div>

<div id="wrapper">
  <app-header-mainsearch-result></app-header-mainsearch-result>

  <div class="clearfix"></div>
  <!-- Header Container / End -->
  <!-- Titlebar
================================================== -->
  <div id="titlebar" class="gradient">

    <div class="container">
      <div class="row">
        <div class="col-md-12" style="font-family: 'Kanit'">

          <h2 id="headPage"></h2>


          <!-- Breadcrumbs -->
          <nav id="breadcrumbs" class="dark">
            <ul>
              <li><a href="index.html">หน้าหลัก</a></li>
              <li>รายการรหัสประเภทธุรกิจ จำแนกตามหมวดธุรกิจ (Section)</li>
            </ul>
          </nav>

        </div>
      </div>
    </div>
  </div>

  <!-- Page Content
  ================================================== -->
  <div class="container">
    <div class="row">
      <div class="col-xl-12">
        <div class="letters-list">
          <a (click)="searchByCategory('A')" id="A">A</a>
          <a (click)="searchByCategory('B')" id="B">B</a>
          <a (click)="searchByCategory('C')" id="C">C</a>
          <a (click)="searchByCategory('D')" id="D">D</a>
          <a (click)="searchByCategory('E')" id="E">E</a>
          <a (click)="searchByCategory('F')" id="F">F</a>
          <a (click)="searchByCategory('G')" id="G">G</a>
          <a (click)="searchByCategory('H')" id="H">H</a>
          <a (click)="searchByCategory('I')" id="I">I</a>
          <a (click)="searchByCategory('J')" id="J">J</a>
          <a (click)="searchByCategory('K')" id="K">K</a>
          <a (click)="searchByCategory('L')" id="L">L</a>
          <a (click)="searchByCategory('M')" id="M">M</a>
          <a (click)="searchByCategory('N')" id="N">N</a>
          <a (click)="searchByCategory('O')" id="O">O</a>
          <a (click)="searchByCategory('P')" id="P">P</a>
          <a (click)="searchByCategory('Q')" id="Q">Q</a>
          <a (click)="searchByCategory('R')" id="R">R</a>
          <a (click)="searchByCategory('S')" id="S">S</a>
          <a (click)="searchByCategory('T')" id="T">T</a>
          <a (click)="searchByCategory('U')" id="U">U</a>
        </div>
      </div>
    </div>
  </div>
  <!-- Spacer -->
  <div class="padding-top-60"></div>
  <!-- Spacer -->

  <!-- Section -->
  <div class="section gray">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 col-lg-8">

          <!-- Section Headline -->
          <div class="section-headline margin-top-60 margin-bottom-40">
            <!-- <h4>Recent Posts</h4> -->
          </div>

          <!-- Blog Post -->
          <div id="show-content"></div>


          <!-- Pagination -->
          <div class="clearfix"></div>
          <div class="row">
            <div class="col-md-12">
              <!-- Pagination -->
              <div class="pagination-container margin-top-10 margin-bottom-20">
                <div id="pagingnation-content"></div>
              </div>
            </div>
          </div>
          <!-- Pagination / End -->

        </div>


        <div class="col-xl-4 col-lg-4 content-left-offset">
          <div class="sidebar-container margin-top-65">

            <div class="sidebar-widget margin-bottom-40">
              <div class="input-with-icon">
                <!-- <input id="autocomplete-input" type="text" placeholder="กรุณาระบุคำค้น แล้วกดปุ่ม Enter"> -->
                <input id="txtSearchByCategory" type="text" style="font-family: 'Kanit'" placeholder="กรุณาระบุคำค้น แล้วกดปุ่ม Enter" (keyup.Enter)="searchData($event.target.value)">
                <i class="icon-material-outline-search"></i>
              </div>
            </div>

            <!-- Sidebar Widget -->
            <div class="sidebar-widget">
              <div class="job-overview" style="font-family: 'Kanit'">
                <div class="job-overview-headline" >คำค้นที่พบบ่อยในหมวดนี้</div>
                <div id="selectHistory"></div>
              </div>
            </div>
            <!-- Widget / End-->

            <!-- Sidebar Widget -->
            <div class="sidebar-widget">
              <div class="job-overview" style="font-family: 'Kanit'">
                <div class="job-overview-headline">คำค้นล่าสุดในหมวดนี้</div>
                  <div id="LastHistory"></div>
              </div>
            </div>
            <!-- Widget / End-->

          </div>
        </div>

      </div>
    </div>

    <!-- Spacer -->
    <div class="padding-top-40"></div>
    <!-- Spacer -->

  </div>
  <!-- Section / End -->

  <!-- Footer
  ================================================== -->
  <div id="footer">

    <!-- Footer Copyrights -->
    <div class="footer-bottom-section">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            จัดทำโดย กรมพัฒนาธุรกิจการค้า กระทรวงพาณิชย์ (สนามบินน้ำ) 563 ถ.นนทบุรี ต.บางกระสอ อ.เมือง จ.นนทบุรี 11000
          </div>
          <div class="col-xl-12">
            © 2020 <strong>Department of Business Development</strong>. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
    <!-- Footer Copyrights / End -->

  </div>
  <!-- Footer / End -->

</div>
<!-- Wrapper / End -->
</body>
</html>
